import { Component, Input, OnInit } from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";

@Component({
  selector: 'app-promotion-info',
  templateUrl: './promotion-info.component.html',
  styleUrls: ['./promotion-info.component.scss']
})
export class PromotionInfoComponent implements OnInit {
  @Input() partnerDetails: any;
  partnerDetailContentURL: any;
  promotionDetailDataObj: any;
  showLoading: any = true;
  @Input() isWebView;
  constructor(
    private rewardService: RewardService,
  ) { }

  ngOnInit(): void {
    if (this.partnerDetails) {
      if (this.partnerDetails.contentPath) {
        this.partnerDetailContentURL = this.partnerDetails.contentPath;
        if(this.isWebView) {
          this.partnerDetailContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'intro');
        } else {
          this.partnerDetailContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'intro');
        }
        this.getPartnerDetailContentAPI();
      }
    }
  }
  getPartnerDetailContentAPI(){
    this.rewardService.getPromotionDetailContent(this.partnerDetailContentURL).subscribe((promotionDetailData: any) => {
        this.showLoading = false;
        this.promotionDetailDataObj = promotionDetailData;
    })
  } 
}
